import { User } from '../user';

export enum RequestStatus {
  Pending = 'pending',
  Accepted = 'accepted',
  Canceled = 'canceled',
  Rejected = 'rejected',
}
export interface Request {
  id?: string;
  requestedForDocumentId?: string;
  requestedForDocumentName?: string;
  respondedById?: string;
  receiverIds: string[];
  receivers?: User[];
  rating?: number;
  status?: RequestStatus;
  type: string;
  createdBy: User;
  createdAt: Date;
  updatedAt: Date;
}

export function createRequest(params: Partial<Request>) {
  return {} as Request;
}
